import React, { useEffect } from 'react'
import Layout from '../Layout'
import Avatar from '../avatar/avatar'
import { useAvatar } from '../avatar/avatar.context'
import Voice from '../voice/voice'
import { VoiceProvider } from '../voice/voice.context'

export default function Demo() {
  const { endSession } = useAvatar()

  const unMount = () => {
    endSession()
  }

  useEffect(() => {
    return unMount
  }, [])

  return (
    <Layout>
      <VoiceProvider>
        <div className='max-w-7xl mx-auto'>
          <div className='flex justify-center items-center h-[calc(100vh-330px)] flex-col'>
            <div className='grid md:grid-cols-2 items-end gap-12'>
              <Avatar />
              <div className='hidden md:block'>
                <Voice />
              </div>
            </div>
          </div>
        </div>
      </VoiceProvider>
    </Layout>
  )
}
